import { useState } from 'react'
import {
  Box,
  Container,
  TextField,
  Button,
  Typography,
  Paper,
  Alert,
} from '@mui/material'
import { LockOutlined } from '@mui/icons-material'
import { useAuthStore } from '@/store/useAuthStore'

export default function PinAuthScreen() {
  const [pin, setPin] = useState('')
  const [error, setError] = useState(false)
  const login = useAuthStore((state) => state.login)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    const success = login(pin)

    if (!success) {
      setError(true)
      setPin('')
      setTimeout(() => setError(false), 3000)
    }
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      }}
    >
      <Container maxWidth="xs">
        <Paper
          elevation={10}
          sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: 3,
          }}
        >
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              bgcolor: 'primary.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 2,
            }}
          >
            <LockOutlined sx={{ fontSize: 32, color: 'white' }} />
          </Box>

          <Typography variant="h4" gutterBottom fontWeight="bold">
            Happy House
          </Typography>

          <Typography variant="body2" color="text.secondary" gutterBottom>
            Enter your PIN to continue
          </Typography>

          {error && (
            <Alert severity="error" sx={{ width: '100%', mt: 2 }}>
              Incorrect PIN. Please try again.
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3, width: '100%' }}>
            <TextField
              fullWidth
              type="password"
              label="PIN"
              value={pin}
              onChange={(e) => setPin(e.target.value)}
              autoFocus
              inputProps={{
                inputMode: 'numeric',
                pattern: '[0-9]*',
                maxLength: 6,
              }}
              sx={{ mb: 2 }}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              disabled={pin.length === 0}
              sx={{ py: 1.5 }}
            >
              Unlock
            </Button>
          </Box>

          <Typography variant="caption" color="text.secondary" sx={{ mt: 3 }}>
            Default PIN: 1234
          </Typography>
        </Paper>
      </Container>
    </Box>
  )
}
